import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
// Image urls come back relative (/lead-images/...), same as SMS media paths.
export const API_PUBLIC = process.env.REACT_APP_API_PUBLIC || 'https://api.mrpatchasphalt.com';

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
});

// Web-form submissions (Driveway500 calculator) for a lead, newest first,
// each with its images. Resolves to { submissions: [], images: [] }.
export const getLeadSubmissions = async (leadId) => {
  const response = await axios.get(`${API_URL}/lead-submissions/lead/${leadId}`, getHeaders());
  return response.data;
};

export const leadImageUrl = (image) => (image && image.url ? `${API_PUBLIC}${image.url}` : '');
